import { emailBlockList } from '@/utils/emailBlockList';
import { TextField } from '@andritzot/metris-web-ui/inputs/textfield';
import { type Control, Controller } from 'react-hook-form';

import { type FormProps } from './types';

const validateEmail = (value: string): boolean | string => {
  if (emailBlockList.some((suffix) => value.endsWith(suffix))) return 'Please enter a valid business email address';
  if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(value)) return 'Invalid email address';
  return true;
};

interface EmailFieldProps {
  control: Control<FormProps>;
}

export function EmailField({ control }: Readonly<EmailFieldProps>) {
  return (
    <Controller
      name="email"
      control={control}
      rules={{ required: 'required', validate: validateEmail }}
      render={({ field, fieldState: { error } }) => (
        <TextField
          {...field}
          label="Email"
          required
          type="email"
          fullWidth
          autoComplete="email"
          error={!!error}
          helperText={error?.message}
        />
      )}
    />
  );
}
